export const normalizePortalIds = multiAccountPortalIds => {
  var _multiAccountPortalId;
  if (!multiAccountPortalIds) return undefined;
  return Array.isArray(multiAccountPortalIds) ? multiAccountPortalIds : (_multiAccountPortalId = multiAccountPortalIds.toArray) === null || _multiAccountPortalId === void 0 ? void 0 : _multiAccountPortalId.call(multiAccountPortalIds);
};
export const buildTargetPortalIdsQueryParam = targetPortalIds => {
  if (!targetPortalIds || targetPortalIds.length === 0) {
    return '';
  }
  return targetPortalIds.map(id => `targetPortalId=${id}`).join('&');
};